module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter05"
    }
  }), _vm._v("Melvin Calvin")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A member of the faculty of the University of California at Berkeley from 1937 until his death in 1997, Calvin received the Nobel Prize in chemistry for identifying the path of carbon in photosynthesis, which led him to a lifelong interest in adapting photosynthetic techniques for energy production. In his final years of research, Calvin studied the use of oil-producing plants as renewable sources of energy. He also spent many years testing the chemical evolution of life and wrote a book on the subject that was published in 1969.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2e68fb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 102
// module chunks = 0